import { useEffect, useState } from 'react';
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { Grid } from '@mui/material';

import { fields, initialValues, schema } from './config';

import useCustomOrderStore from '../../store/custom_orders';

import useInvoiceActionStore from '../../store/invoice_actions';


const EditWigOrder = ( { ignore_id = false, appt_info }) => {
  const [formFields, setFormFields] = useState([...fields.map(field => ({...field}))]);
  const [initValues, setInitValues] = useState({...initialValues});

  // const setPendingCODialog = useCustomOrderStore((state) => state.setPendingCODialog);

  const setPendingIADialog = useInvoiceActionStore((state) => state.setPendingIADialog);

  let { customer_id, customer_name, customer_phone, stylist_id, stylist_name, appointment_id, appointment_title, appointment_date, order_type, invoice_id } = appt_info || {};

  useEffect(() => {
    // setPendingCODialog(null);
    setPendingIADialog(null)
  }, [appt_info]);

  useEffect(() => {
    setInitValues(ov => {
      let nv = {
        ...ov
      }
      if (appointment_id) nv.appointment_id = appointment_id;
      if (customer_id) nv.customer_id = customer_id;
      if (stylist_id) nv.stylist_id = stylist_id;
      if (order_type) nv.order_type = order_type;
      if (invoice_id) nv.invoice_id = invoice_id;
      return nv
    })

    let updatedFields = formFields.map(field => {
        if (field.name === 'customer_id' && customer_id) {
         return {
           ...field,
           serverOptions: [{customer_id, full_name: customer_name, mobile_phone: customer_phone}]
         }
        }
        if (field.name === 'stylist_id' && stylist_id) {
         return {
           ...field,
           serverOptions: [{stylist_id, full_name: stylist_name}]
         }
        }
        return field;
      })

    setFormFields(updatedFields);

  }, [appointment_id, customer_id, stylist_id]);

  return (
    <EditForm title={"Wig Order"} initialValues={initValues} fields={formFields} schema={schema} url={"wig_orders"} ignore_id={ignore_id} invalidate_queries={[["invoices"]]}>
      
    </EditForm>
  );
}

export default EditWigOrder;